import BrowsePage from 'src/dispensary/core-menu/browse';

export default BrowsePage;
